import { Copy, Bookmark, Sparkles } from "lucide-react";
import { toast } from "sonner";

export const splitAiContent = (raw = "") => {
  const text = raw.replace(/\[\[STEP:\d\]\]/g, "").replace(/\[\[[A-Z/:\d]*\]?$/, "");
  const m = text.match(/\[\[REWRITE\]\]([\s\S]*?)(\[\[\/REWRITE\]\]|$)/);
  if (!m) return { before: text.trim(), rewrite: null, after: "" };
  return {
    before: text.slice(0, m.index).trim(),
    rewrite: m[1].trim(),
    after: text.slice(m.index + m[0].length).trim(),
  };
};

const RewriteCard = ({ text, onSave }) => {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Copied to clipboard");
    } catch {
      toast.error("Couldn't copy");
    }
  };
  return (
    <div data-testid="rewrite-card" className="my-3 rounded-2xl p-5 border border-cg-gold/50 bg-[linear-gradient(135deg,rgba(242,181,68,0.10),rgba(140,79,214,0.18))] shadow-[0_0_30px_rgba(242,181,68,0.15)]">
      <p className="flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-[0.25em] text-cg-gold mb-3">
        <Sparkles className="h-3 w-3" /> Your declaration to the universe
      </p>
      <p className="font-serif text-lg leading-relaxed text-cg-textp whitespace-pre-wrap" data-testid="rewrite-text">{text}</p>
      <div className="mt-4 flex gap-2">
        <button onClick={copy} data-testid="rewrite-copy-button"
          className="inline-flex items-center gap-1.5 rounded-full border border-cg-gold/50 px-3 py-1.5 text-xs text-cg-gold hover:bg-[rgba(242,181,68,0.12)] transition-colors">
          <Copy className="h-3 w-3" /> Copy
        </button>
        <button onClick={() => onSave(text)} data-testid="rewrite-save-button"
          className="inline-flex items-center gap-1.5 rounded-full bg-cg-gold/90 px-3 py-1.5 text-xs text-cg-deep hover:bg-cg-gold transition-colors">
          <Bookmark className="h-3 w-3" /> Save to journal
        </button>
      </div>
    </div>
  );
};

export const AiContent = ({ content, onSave }) => {
  const { before, rewrite, after } = splitAiContent(content);
  return (
    <>
      {before && <div className="whitespace-pre-wrap">{before}</div>}
      {rewrite && <RewriteCard text={rewrite} onSave={onSave} />}
      {after && <div className="whitespace-pre-wrap">{after}</div>}
    </>
  );
};
